import './form-buttons.scss';

import { useHistory, useParams } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { useUser } from 'features/users/context/userContext';
import { labels } from 'locales/en.label';

interface FormButtonsProps {
	loading?: boolean;
	dirty: boolean;
	onSaveClick?: () => void;
	onContinueClick: () => void;
}

const tabs = ['seasons', 'competitors', 'rates', 'autopilot'];

export const FormButtons = ({
	loading = false,
	dirty,
	onSaveClick,
	onContinueClick,
}: FormButtonsProps) => {
	const { isReadOnly } = useUser();
	const history = useHistory();
	const { selectedTab } = useParams<{ selectedTab: string }>();

	const goBack = () => {
		const index = tabs.findIndex((tab) => tab === selectedTab) - 1;
		history.push(`/rules/${tabs[index]}`);
	};

	return (
		<div className='form-buttons'>
			<div className='left'>
				{selectedTab !== 'seasons' && (
					<Button
						type='button'
						disabled={loading}
						className='back'
						onClick={goBack}
					>
						{labels.rules.back}
					</Button>
				)}
				<Button
					type='submit'
					disabled={loading || !dirty || isReadOnly}
					onClick={onSaveClick}
				>
					{labels.common.save}
				</Button>
			</div>
			<div className='right'>
				<Button
					type='button'
					disabled={loading}
					className='continue'
					onClick={onContinueClick}
				>
					{selectedTab === 'autopilot'
						? labels.rules.finish
						: labels.rules.continue}
				</Button>
			</div>
		</div>
	);
};
